import { useEffect, useState } from "react";
import DashboardLayout from "../Layouts/DashboardLayout";

export default function Customers() {
  const [customers, setCustomers] = useState([]);
  const [filters, setFilters] = useState({
    search: "",
  });
  const [showView, setShowView] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [showOrders, setShowOrders] = useState(false);

  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [customerOrders, setCustomerOrders] = useState([]);
  const [showAdd, setShowAdd] = useState(false);

  const [form, setForm] = useState({
    name: "",
    mobile: "",
    email: "",
    address: "",
    gst_no: "",
  });

  useEffect(() => {
    loadCustomers();
  }, []);

  const loadCustomers = async () => {
    try {
      const res = await fetch("/api/customers/", {
        credentials: "include",
      });

      const data = await res.json();

      if (data.status === "success") {
        setCustomers(data.data);
      } else {
        alert(data.message);
      }
    } catch (err) {
      console.error(err);
      alert("Failed to load customers");
    }
  };

  const viewCustomer = async (id) => {
    const res = await fetch(`/api/customers/${id}`, {
      credentials: "include",
    });

    const data = await res.json();

    if (data.status === "success") {
      setSelectedCustomer(data.customer);
      setShowView(true);
    }
  };

  const editCustomer = async (id) => {
    const res = await fetch(`/api/customers/${id}`, {
      credentials: "include",
    });

    const data = await res.json();

    if (data.status !== "success") {
      alert(data.message);
      return;
    }

    setForm({
      name: data.customer.name,
      mobile: data.customer.mobile || "",
      email: data.customer.email || "",
      address: data.customer.address || "",
      gst_no: data.customer.gst_no || "",
    });

    setSelectedCustomer(data.customer);

    setShowEdit(true);
    setShowAdd(true); // <-- Missing
  };

  const viewOrders = async (id) => {
    const res = await fetch(`/api/customers/${id}/orders`, {
      credentials: "include",
    });

    const data = await res.json();

    if (data.status === "success") {
      setCustomerOrders(data.data);

      setShowOrders(true);
    }
  };

  const updateCustomer = async () => {
    const res = await fetch(
      `/api/customers/${selectedCustomer.id}`,
      {
        method: "PUT",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(form),
      },
    );

    const data = await res.json();

    if (data.status === "success") {
      alert("Customer Updated");

      setShowEdit(false);

      loadCustomers();
    } else {
      alert(data.message);
    }
  };

  const saveCustomer = async () => {
    if (!form.name.trim()) {
      alert("Customer name is required");
      return;
    }

    try {
      const res = await fetch("/api/customers/", {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(form),
      });

      const data = await res.json();

      if (data.status !== "success") {
        alert(data.message);
        return;
      }

      alert("Customer Added");

      setShowAdd(false);

      setForm({
        name: "",
        mobile: "",
        email: "",
        address: "",
        gst_no: "",
      });

      loadCustomers();
    } catch (err) {
      console.error(err);
      alert("Server Error");
    }
  };

  const closeModal = () => {
  setShowAdd(false);
  setShowEdit(false);
  setSelectedCustomer(null);

  setForm({
    name: "",
    mobile: "",
    email: "",
    address: "",
    gst_no: "",
  });
};

  const filtered = customers.filter((c) => {
    return (
      c.name?.toLowerCase().includes(filters.search.toLowerCase()) ||
      c.mobile?.includes(filters.search) ||
      c.customer_code?.toLowerCase().includes(filters.search.toLowerCase())
    );
  });

  return (
    <DashboardLayout>
      <div className="space-y-8">
        <div className="flex justify-between items-center">
          <div>
            <h1 className="text-2xl font-serif">Customers</h1>
            <p className="text-sm text-gray-400">
              Manage Catering & Bulk Order Customers
            </p>
          </div>

          <button
            onClick={() => {
              setShowEdit(false);
              setSelectedCustomer(null);

              setForm({
                name: "",
                mobile: "",
                email: "",
                address: "",
                gst_no: "",
              });

              setShowAdd(true);
            }}
            className="bg-yellow-500 text-black px-5 py-2 rounded-lg font-semibold"
          >
            + Add Customer
          </button>
        </div>

        <input
          placeholder="Search customer..."
          value={filters.search}
          onChange={(e) =>
            setFilters({
              ...filters,
              search: e.target.value,
            })
          }
          className="w-full p-3 rounded-lg bg-black border border-zinc-700"
        />

        <div className="rounded-xl border border-zinc-700 overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-zinc-900 text-yellow-400">
              <tr>
                <th className="p-3 text-left">Code</th>
                <th className="p-3">Customer</th>
                <th className="p-3">Mobile</th>
                <th className="p-3">Email</th>
                <th className="p-3">GST</th>
                <th className="p-3">Actions</th>
              </tr>
            </thead>

            <tbody>
              {filtered.length === 0 && (
                <tr>
                  <td colSpan="6" className="text-center p-8 text-gray-400">
                    No Customers Found
                  </td>
                </tr>
              )}

              {filtered.map((c) => (
                <tr
                  key={c.id}
                  className="border-t border-zinc-700 hover:bg-zinc-900"
                >
                  <td className="p-3">{c.customer_code}</td>

                  <td className="p-3">{c.name}</td>

                  <td className="p-3 text-center">{c.mobile || "-"}</td>

                  <td className="p-3 text-center">{c.email || "-"}</td>

                  <td className="p-3 text-center">{c.gst_no || "-"}</td>

                  <td className="p-3">
                    <div className="flex justify-center gap-3">
                      <button
                        onClick={() => viewCustomer(c.id)}
                        className="text-blue-400 hover:text-blue-300"
                      >
                        View
                      </button>

                      <button
                        onClick={() => editCustomer(c.id)}
                        className="text-yellow-400 hover:text-yellow-300"
                      >
                        Edit
                      </button>

                      <button
                        onClick={() => viewOrders(c.id)}
                        className="text-green-400 hover:text-green-300"
                      >
                        Orders
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {showAdd && (
          <div className="fixed inset-0 bg-black/70 flex justify-center items-center z-50">
            <div className="bg-zinc-900 border border-yellow-500 rounded-xl w-[600px] p-6">
              <div className="flex justify-between items-center mb-6">
                <h2 className="text-2xl text-yellow-400 font-bold">
                  {showEdit ? "Edit Customer" : "Add Customer"}
                </h2>

                <button onClick={closeModal} className="text-xl">
                  ✕
                </button>
              </div>

              <div className="grid grid-cols-2 gap-4">
                <div className="col-span-2">
                  <label>Name</label>

                  <input
                    value={form.name}
                    onChange={(e) =>
                      setForm({
                        ...form,
                        name: e.target.value,
                      })
                    }
                    className="w-full mt-1 p-2 rounded bg-black border border-zinc-700"
                  />
                </div>

                <div>
                  <label>Mobile</label>

                  <input
                    value={form.mobile}
                    onChange={(e) =>
                      setForm({
                        ...form,
                        mobile: e.target.value,
                      })
                    }
                    className="w-full mt-1 p-2 rounded bg-black border border-zinc-700"
                  />
                </div>

                <div>
                  <label>Email</label>

                  <input
                    value={form.email}
                    onChange={(e) =>
                      setForm({
                        ...form,
                        email: e.target.value,
                      })
                    }
                    className="w-full mt-1 p-2 rounded bg-black border border-zinc-700"
                  />
                </div>

                <div className="col-span-2">
                  <label>GST Number</label>

                  <input
                    value={form.gst_no}
                    onChange={(e) =>
                      setForm({
                        ...form,
                        gst_no: e.target.value,
                      })
                    }
                    className="w-full mt-1 p-2 rounded bg-black border border-zinc-700"
                  />
                </div>

                <div className="col-span-2">
                  <label>Address</label>

                  <textarea
                    rows={3}
                    value={form.address}
                    onChange={(e) =>
                      setForm({
                        ...form,
                        address: e.target.value,
                      })
                    }
                    className="w-full mt-1 p-2 rounded bg-black border border-zinc-700"
                  />
                </div>
              </div>

              <div className="flex justify-end gap-3 mt-6">
                <button
                  onClick={closeModal}
                  className="bg-zinc-700 px-5 py-2 rounded"
                >
                  Cancel
                </button>

                <button
                  onClick={showEdit ? updateCustomer : saveCustomer}
                  className="bg-yellow-500 text-black px-5 py-2 rounded font-semibold"
                >
                  {showEdit ? "Update Customer" : "Save Customer"}
                </button>
              </div>
            </div>
          </div>
        )}

        {showView && selectedCustomer && (
          <div className="fixed inset-0 bg-black/70 flex justify-center items-center z-50">
            <div className="bg-zinc-900 rounded-xl border border-blue-500 w-[600px] p-6">
              <h2 className="text-2xl text-blue-400 font-bold mb-6">
                Customer Details
              </h2>

              <div className="grid grid-cols-2 gap-5">
                <div>
                  <p className="text-gray-400 text-sm">Code</p>

                  <p>{selectedCustomer.customer_code}</p>
                </div>

                <div>
                  <p className="text-gray-400 text-sm">Name</p>

                  <p>{selectedCustomer.name}</p>
                </div>

                <div>
                  <p className="text-gray-400 text-sm">Mobile</p>

                  <p>{selectedCustomer.mobile || "-"}</p>
                </div>

                <div>
                  <p className="text-gray-400 text-sm">Email</p>

                  <p>{selectedCustomer.email || "-"}</p>
                </div>

                <div className="col-span-2">
                  <p className="text-gray-400 text-sm">GST</p>

                  <p>{selectedCustomer.gst_no || "-"}</p>
                </div>

                <div className="col-span-2">
                  <p className="text-gray-400 text-sm">Address</p>

                  <p>{selectedCustomer.address || "-"}</p>
                </div>
              </div>

              <div className="flex justify-end mt-6">
                <button
                  onClick={() => setShowView(false)}
                  className="bg-zinc-700 px-5 py-2 rounded"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        )}

        {showOrders && (
          <div className="fixed inset-0 bg-black/70 flex justify-center items-center z-50">
            <div className="bg-zinc-900 border border-green-500 rounded-xl w-[1000px] max-h-[90vh] overflow-y-auto p-6">
              <div className="flex justify-between mb-6">
                <h2 className="text-2xl text-green-400 font-bold">
                  Customer Orders
                </h2>

                <button onClick={() => setShowOrders(false)}>✕</button>
              </div>

              <table className="w-full">
                <thead className="bg-zinc-800">
                  <tr>
                    <th className="p-3">Order</th>

                    <th>Branch</th>

                    <th>Type</th>

                    <th>Event</th>

                    <th>Total</th>

                    <th>Advance</th>

                    <th>Balance</th>

                    <th>Status</th>
                  </tr>
                </thead>

                <tbody>
                  {customerOrders.map((order) => (
                    <tr key={order.id} className="border-t border-zinc-700">
                      <td className="p-3">{order.order_no}</td>

                      <td>{order.branch}</td>

                      <td>{order.order_type}</td>

                      <td>{order.event_date}</td>

                      <td>₹{order.grand_total.toFixed(2)}</td>

                      <td className="text-green-400">
                        ₹{order.advance_paid.toFixed(2)}
                      </td>

                      <td className="text-red-400">
                        ₹{order.balance_amount.toFixed(2)}
                      </td>

                      <td>{order.order_status}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    </DashboardLayout>
  );
}
